import React, { useState,useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Icon, Button, Loader } from "semantic-ui-react";
import { createLineItem } from "../../actions";
import MerchandiseForm from "./merchandiseForm";

function MerchandiseLineItems(props) {
  const [isAdding, setIsAdding] = useState(false);
  const dispatch = useDispatch();

  const totalItem = useSelector((state) => state.Shipment.totalItem)

     
  const   updateAddStatus = useCallback(
    () => {
      setIsAdding(false);
    },
    [isAdding],
  )



  const {

    invoiceId,
    invoiceIndex,
    invoiceItemIndex,
    isFormDisabled,
    translate,
    jobWheels,
    merchandiseId
  } = props;


  return (
    
         <>
        <MerchandiseForm

          invoiceIndex={invoiceIndex}
          invoiceId={invoiceId}
          invoiceItemIndex={invoiceItemIndex}
          isFormDisabled={isFormDisabled}
          translate={translate}
          jobWheels={jobWheels}
          totalItem={totalItem}
        />
        <Button
          basic
          color="blue"
          className="btn-add-item"
          id={`addLineItem-${invoiceId}-${merchandiseId}`}
          onClick={() => {
            setIsAdding(true);
            dispatch(
              createLineItem(invoiceId,invoiceItemIndex,totalItem , updateAddStatus)
            );
          }}
         disabled={isFormDisabled || isAdding}
        >
          {!isAdding ? (
            <span>
              <Icon name="add circle" disabled={isFormDisabled} /> {translate("ADD_LINE_ITEM",{ns:["default","lineItem"]})}
            </span>
          ) : (
            <span>
              <Loader
                active
                inline
                size="mini"
                style={{ marginRight: "10px" }}
              />
              {translate("ADDING_LINE_ITEM",{ns:["default","lineItem"]})}
            </span>
          )}
        </Button>
        </>
  );
}

export default React.memo(MerchandiseLineItems)
